/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/*
 * Extras Menu component
 *
 * @param {number} x: horizontal center of the button calling the menu
 * @param {function} onClose: callback to handle a close menu request
 *
 * Each child element will be placed in a menu entry row.
 * By default, clicking on an entry will close the menu.
 * If a child element has the class name 'extra-menu-no-close' included,
 * then the menu won't be closed when clicking on that entry.
 */
import React, {useEffect, useRef, useState} from 'react';
import './ExtrasMenu.scss';

const CARET_WIDTH = 16; // Change this if caret width changes (1/2 of caret width)

function ExtrasMenu({x, onClose, children}) {
    const ref = useRef(null);
    const [caretPositionStyle, setCaretPositionStyle] = useState({});
    const [menuPositionStyle, setMenuPositionStyle] = useState({});

    const closeMenu = () => {
        if (onClose) {
            onClose();
        }
    };

    const setMenuPosition = () => {
        const xx = x !== undefined ? Number(x) : 0;
        const MENU_RIGHT = 3;

        const caretRight = Math.abs(window.innerWidth - xx - CARET_WIDTH * 0.5 - MENU_RIGHT + 1);
        setCaretPositionStyle({right: `${caretRight}px`});
        setMenuPositionStyle({right: `${MENU_RIGHT}px`});
    };

    useEffect(() => {
        window.addEventListener('resize', closeMenu);
        setMenuPosition();
        return () => {
            window.removeEventListener('resize', closeMenu);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!caretPositionStyle?.right) {
        return null;
    }

    return (
        <div className="extras-mask" onClick={closeMenu}>
            <div className="extras-menu" ref={ref} style={menuPositionStyle}>
                <div className="caret" style={caretPositionStyle}></div>
                <div className="list">
                    {React.Children.map(children, child => {
                        if (child) {
                            if (
                                'className' in child.props &&
                                child.props.className.indexOf('extra-menu-no-close') !== -1
                            ) {
                                return (
                                    <div
                                        className="entry"
                                        onClick={e => {
                                            e.stopPropagation();
                                        }}
                                    >
                                        {child}
                                    </div>
                                );
                            }
                            return <div className="entry">{child}</div>;
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
}

export default ExtrasMenu;
